import React from 'react';
import { Link } from 'react-router-dom';
import { GlitchDiscoBall } from '../components';
import LottieAnimation from '../components/LottieAnimation';
import mirrorBallData from '../assets/lottie/mirror-ball-2.json';
// import logoVideo from '../assets/video/party-resume-logo-cropped.mp4';

/**
 * LandingPage - The Stanchion (Screen 01)
 * Design: Black background, white text, minimalist, dramatic
 * Purpose: First impression, sets the tone for the app
 */
export default function LandingPage() {
  return (
    <div className="min-h-screen bg-black flex flex-col items-center justify-center p-8 relative overflow-hidden">
      {/* Background video */}
      {/* <video
        autoPlay={true}
        loop
        muted
        preload={`auto`}
        playsInline
        webkit-playsInline
        className="absolute top-0 h-[360px] w-[450px] sm:h-[540px] sm:w-[540px] object-cover z-0 opacity-100"
      >
        <source src={logoVideo} type="video/mp4" />
      </video> */}

      {/* Lottie mirror ball */}
      <div className="mb-12 md:mb-16 relative z-10">
        <LottieAnimation animationData={mirrorBallData} width={300} height={300} />
      </div>

      {/* Tagline */}
      <h1 className="font-mono text-2xl md:text-4xl lg:text-5xl font-bold uppercase tracking-wider text-white mb-4 text-center relative z-10">
        FIND YOUR PARTY.
      </h1>
      <h1 className="font-mono text-2xl md:text-4xl lg:text-5xl font-bold uppercase tracking-wider text-white mb-12 md:mb-16 text-center relative z-10">
        FIND YOUR PEOPLE.
      </h1>

      {/* Enter button */}
      <Link
        to="/login"
        className="
          px-12 py-4
          bg-white text-black
          font-mono text-lg font-bold uppercase tracking-wider
          border-2 border-white
          hover:bg-black hover:text-white
          transition-colors duration-200
          inline-block
          relative z-10
        "
      >
        ENTER
      </Link>

      {/* Scanlines overlay for retro effect */}
      <div
        className="fixed inset-0 pointer-events-none opacity-5"
        style={{
          backgroundImage: 'repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(255,255,255,0.1) 2px, rgba(255,255,255,0.1) 4px)',
        }}
      />

      {/* Subtle corner decorations */}
      <div className="absolute top-8 left-8 w-16 h-16 border-l-2 border-t-2 border-white opacity-20" />
      <div className="absolute top-8 right-8 w-16 h-16 border-r-2 border-t-2 border-white opacity-20" />
      <div className="absolute bottom-8 left-8 w-16 h-16 border-l-2 border-b-2 border-white opacity-20" />
      <div className="absolute bottom-8 right-8 w-16 h-16 border-r-2 border-b-2 border-white opacity-20" />

      {/* Brand watermark */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <p className="font-mono text-xs uppercase tracking-widest text-gray-600">
          Party Resume
        </p>
      </div>
    </div>
  );
}
